/* ★ REKOD LARIAN PADA PIL CARD — override (keputusan user 2026-11-03: "override je status,
 *   mcm replace video").
 *
 * Pil status card (`setStatusAkaun.tiktok_setN[akaun]`, utils/statusAkaunKad.js) kini memapar
 * larian TERAKHIR — dari slot kalendar ATAU tick card, platform apa pun. Sebelum ini hanya
 * larian slot kalendar menulis pil; run tick card TikTok/FB tidak menyentuhnya.
 *
 * `pf` pada rekod = platform larian terakhir: 'tt' TikTok · 'fb' Facebook · 'sp' telefon
 * (Shopee). Ia memberitahu naik taraf di bawah kunci robot mana yang perlu dibaca
 * (`setStatuses.tiktok_setN` / `fb_setN`). WAJIB dicop setiap kali rekod ditanda 'running' —
 * gabungStatusAkaun MENGGABUNG, jadi pf lama (cth 'fb') yang tertinggal akan membuat larian
 * TikTok membaca hasil robot FB yang basi.
 *
 * ⚠️ KEMBAR: effect graduasi SLOT (WorkspaceView) membaca kunci yang SAMA melalui slot
 *    (`kunciStatusSlot`). Kedua-duanya digabung dalam SATU panggilan tulisStatusAkaunKad —
 *    dua panggilan dalam effect yang sama saling menindih (productsRef dikemas kini selepas
 *    render, jadi tulisan kedua membina dari data basi dan menyimpannya ke Firestore).
 */
import { gabungStatusAkaun, SET_KAD_STATUS } from './statusAkaunKad';

const KUNCI_ROBOT = { tt: 'tiktok', fb: 'fb' };

/* Rekod 'running' bagi set-set satu card untuk akaun kalendar yang dibuka. Pulang peta
   setStatusAkaun baharu. md 'now' = Post now (label Posted bila siap). */
export function petaMulaLarian(peta, sets, akaunId, { pf, md = '', nama = '' } = {}) {
    if (!akaunId || !Array.isArray(sets) || (!KUNCI_ROBOT[pf] && pf !== 'sp')) return peta || {};
    let baru = peta || {};
    sets.forEach((s) => {
        baru = gabungStatusAkaun(baru, s, akaunId, { st: 'running', sb: '', md: md === 'now' ? 'now' : '', pf, nama, masa: Date.now() });
    });
    return baru;
}

/* Rekod pil yang masih 'running' tetapi robot (TikTok/FB) sudah menulis hasil terminal pada
   `setStatuses` → senarai { pid, s, akaunId, st, sb } untuk tulisStatusAkaunKad.
   Telefon ('sp') dilangkau: robot telefon menulis rekodnya sendiri secara terus.
   Rekod tanpa pf (larian sebelum 3 Nov) dilangkau — graduasi slot sedia ada menjaganya. */
export function naikTarafRekodKad(products) {
    const keluar = [];
    (products || []).forEach((p) => {
        const peta = p?.setStatusAkaun;
        if (!peta) return;
        SET_KAD_STATUS.forEach((s) => {
            const bagiSet = peta[`tiktok_${s}`];
            if (!bagiSet) return;
            for (const kA in bagiSet) {
                const r = bagiSet[kA];
                const robot = KUNCI_ROBOT[r?.pf];
                if (!robot || r.st !== 'running') continue;
                const st = p.setStatuses?.[`${robot}_${s}`];
                if (!st || st === 'running') continue;
                keluar.push({ pid: p.id, s, akaunId: kA, st, sb: p.setStatusReason?.[`${robot}_${s}`] || '' });
            }
        });
    });
    return keluar;
}
